// pages/Dashboard.jsx
import Inverstors from "../../components/home/investorsComponents/Inverstors";
import HomeLayout from "../../components/home/HomeLayout";

export default function InvestorsPage() {
  return (
    <HomeLayout>
      <Inverstors />
    </HomeLayout>
  );
}
